// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_31-1";
export var rateTableServiceLevelDropdown = "_31-3";
export var rateTableTypeDropdown = "_31-0";
export var rateTableValueModeDropdown = "_31-2";